<template>
  <div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        {{ isDirect ? '换货' : '' }}合同基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                {{ isDirect ? '换货' : '' }}合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                原合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.oldContractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.projectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.rfinalCustomerName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.contractTime }}
              </div>
            </div>
          </div>

          <div
            v-if="$route.query.rcontractType === '退货合同' "
            class="rj-col-3"
          >
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际退款金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.rrefundAmount ? info.rrefundAmount : 0 }}元
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际结算金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.actualAmount || 0 }}元
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.rdeductionAmount? info.rdeductionAmount:0 }}元
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.unallocatedAmount ? info.unallocatedAmount:0 }}元
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.distribution }}%
              </div>
            </div>
          </div>
          <div v-if="!isDirect" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                原合同分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.oldContractDeductionAmount }}元
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$route.query.rcontractType === '退货合同'" class="add-btn-wrap">
      <el-button
        :disabled="isDisabled"
        :loading="isBtnLoading"
        type="primary"
        @click="addtransferOrder"
      >
        新建电汇单
      </el-button>
    </div>

    <div v-loading="tableLoading" class="tableBody">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="$route.query.rcontractType === '退货合同'"
          type="selection"
          width="55"
          :selectable="selectable"
        />
        <el-table-column type="index" width="50" label="序号" align="left" fixed="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" fixed="left" width="210px" />
        <el-table-column
          v-if="$route.query.rcontractType === '退货合同'"
          prop="allocationAmount"
          label="原合同分配金额"
          align="right" header-align="left"
        />
        <el-table-column prop="remittanceAmount" label="汇款金额" align="right" header-align="left" width="120px" />
        <el-table-column prop="remittanceDate" label="汇款日期" align="left" width="120" />
        <el-table-column prop="account" label="汇入账户" align="left" width="" />
        <el-table-column prop="accountCompany" label="汇入公司" align="left" />
        <el-table-column prop="summary" label="摘要" align="left" />
        <el-table-column prop="unusedAmount" label="可用余额（元）" align="right" header-align="left" width="120px" />

        <el-table-column prop="assignAmount" label="本次分配金额（元）" align="left" fixed="right" width="200">
          <template v-slot="{row}">
            <el-input-number
              v-model="row.assignAmount"
              :disabled="row.virtualFlag"
              :precision="2"
              :min="0"
              label="描述文字"
              style="width:80%;"
              @blur="judgeBlur(row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button type="primary" style="margin-top:20px" @click="showDialog">
      确认分配
    </el-button>
    <span>本次分配金额：
      <span class="money">{{ assignAllTotal }} 元</span>
    </span>

    <!-- 确认一次弹框 -->
    <sureAAllocation
      :dialog-form-visible="dialogFormVisible"
      :data="sureData"
      :is-direct="isDirect"
      @on-status-dialog="updataDialogFormVisible"
      @on-ok="onSuccessBack"
    />

    <!-- 确认二次弹框 -->
    <confirm-allocation-dialog ref="confirmAllocationDialog" />
  </div>
</template>

<script>
import { assignSelectAssignInfoByUserCodeAndContractNum, getContractDetailAllInfoById, addReTelegraphicTransfer, checkContractAbandonAssign } from '@/API/index.js';
import { Subtr, numDiv, numAdd } from '@/libs/util';
import sureAAllocation from './sureAAllocation.vue';
import ConfirmAllocationDialog from './ConfirmAllocationDialog.vue';

export default {
  components: {
    sureAAllocation,
    ConfirmAllocationDialog
  },

  data () {
    return {
      info: {
        unAssignAll: 0,
        distribution: 0
      },
      dialogFormVisible: false,
      loading: false,
      tableData: [],
      tableLoading: false,
      sureData: {
        dialogData: [],
        contractType: null,
        contractId: 0
      },
      // 新建电汇单laoding
      isBtnLoading: false
    };
  },

  computed: {
    assignAllTotal () {
      let count = this.tableData.filter(row => row.assignAmount > 0).reduce((pre, cur) => numAdd(pre, cur.assignAmount), 0);
      return count;
    },

    // 禁用新建电汇单【实际结算金额 <= 实际退款金额 || 列表有一条电汇单记录】
    isDisabled () {
      if (!this.info.actualAmount) return true;
      if (this.info.actualAmount <= this.info.rrefundAmount) return true;
      if (this.tableData.some(item => item.virtualFlag)) return true;
      return false;
    },

    // 是否是直签分配
    isDirect () {
      return this.$route.query.type === 'direct';
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    initData () {
      this.queryDetail();
    },

    queryDetail () {
      getContractDetailAllInfoById(this.$route.query.contractId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.info = json.data;
          if (this.info.rdeductionAmount && this.info.actualAmount && (this.info.actualAmount - 0) !== 0) {
            this.info.distribution = numDiv(this.info.rdeductionAmount, this.info.actualAmount) * 100;
          } else {
            this.info.distribution = 0;
          }
          this.sureData.contractId = this.info.contractId;
          this.sureData.contractType = this.info.contractType;
        }
        this.queryList();
      });
    },

    // 增加退换货业务逻辑
    queryList () {
      let { contractId, rcontractType } = this.$route.query;
      let params = { contractId, contractType: rcontractType };
      assignSelectAssignInfoByUserCodeAndContractNum(params).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          data.forEach((item) => {
            item.assignAmount = 0;
            // 【退货合同】&& 虚拟电汇单金额： 实际结算金额 - 实际退款金额
            if (rcontractType === '退货合同' && item.virtualFlag) {
              let num = Subtr(this.info.actualAmount, this.info.rrefundAmount);
              item.assignAmount = Number(num);
            }
          });

          this.tableData = data;
        }
      });
    },

    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },

    onSuccessBack (item) {
      let data = {
        rrefundAmount: this.info.rrefundAmount,
        ...item
      };
      this.$refs.confirmAllocationDialog.openDialog(data);
    },

    // 失去焦点
    judgeBlur (row) {
      this.$route.query.rcontractType === '退货合同' ? this.retreatAssignBlur(row) : this.assignBlur(row);
    },

    // 退货
    retreatAssignBlur (row) {
      if (this.info.unallocatedAmount < row.assignAmount) {
        row.assignAmount = this.info.unallocatedAmount;
      }

      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = numAdd(num, item.assignAmount);
        }
      });
      if (num > this.info.unallocatedAmount) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    },

    // 换货
    assignBlur (row) {
      if (row.unusedAmount < row.assignAmount) {
        row.assignAmount = row.unusedAmount;
      }

      let num = 0;
      this.sureData.dialogData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = numAdd(num, item.assignAmount);
        }
      });
      if (num > this.info.unAssignAll) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    },

    // 新建电汇单
    addtransferOrder () {
      let params = { contractId: this.$route.query.contractId };
      this.isBtnLoading = true;
      addReTelegraphicTransfer(params)
        .finally(() => {
          this.isBtnLoading = false;
        })
        .then(res => {
          let { status, data } = res.data;
          if (status === '200' && data) {
            this.queryList();
          }
        });
    },

    // 禁用新建的电汇单
    selectable (row) {
      if (row.virtualFlag) {
        return false;
      } else {
        return true;
      }
    },

    // 更改 table 选择项
    handleSelectionChange (arr) {
      // 实际退款金额;
      let rrefundAmount = this.info.rrefundAmount;

      // 获取真实电汇单
      let list = arr.filter(row => !row.virtualFlag);

      this.tableData.forEach(row => {
        if (!row.virtualFlag) {
          row.assignAmount = 0;
        }
      });

      if (!list.length) return false;

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.allocationAmount <= rrefundAmount) {
          item.assignAmount = item.allocationAmount;

          rrefundAmount = Number(Subtr(rrefundAmount, item.allocationAmount));
        } else if (item.allocationAmount > rrefundAmount && rrefundAmount > 0) {
          item.assignAmount = rrefundAmount;
          rrefundAmount = 0;
        } else {
          break;
        }
      }

      let newList = list.filter(row => row.assignAmount > 0);
      if (newList.length !== list.length) {
        this.$refs.multipleTable.clearSelection();
        newList.forEach(row => this.$refs.multipleTable.toggleRowSelection(row));
      }
    },

    // 分配
    showDialog () {
      let tableData = JSON.parse(JSON.stringify(this.tableData));
      let arr = tableData.filter(item => item.assignAmount > 0);

      arr.forEach((item) => {
        item.contractNum = this.info.contractNum;
        item.actualAmount = this.info.actualAmount;
      });

      this.sureData.dialogData = arr;

      // 本次分配金额合计
      let sumCount = arr.reduce((pre, cur) => numAdd(cur.assignAmount, pre), 0);

      if (this.$route.query.rcontractType === '退货合同') {
        this.checkReturnGoods(arr, sumCount);
      } else {
        this.checkExchangeGoods(sumCount);
      }
    },

    /**
     * @desc 退货合同提交验证
     * @param {array} arr 【本次分配金额】只有金额的集合
     * @param {number} total 【本次分配金额】总数
     */
    checkReturnGoods (arr, total) {
      if (total !== this.info.actualAmount) {
        return this.$notify.warning('本次分配金额应和实际结算金额一致，请进行调整');
      }

      // 当前电汇单列表项应满足【本次分配金额】<= 【原合同分配金额】
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (!item.virtualFlag && item.assignAmount > item.allocationAmount) {
          return this.$notify.warning('电汇单的本次分配金额要小于等于原合同分配金额，请进行调整');
        }
      }

      // 【实际结算金额】>=【实际退款金额】则校验【新增电汇电汇单金额】
      if (this.info.actualAmount > this.info.rrefundAmount) {
        let num = Subtr(this.info.actualAmount, this.info.rrefundAmount);
        let obj = arr.find(item => item.virtualFlag);
        if (Number(num) !== obj.assignAmount) {
          return this.$notify.warning('新增加的电汇单分配金额为：实际结算金额-实际退款金额');
        }
      }

      this.checkReturnContract();
    },

    // 退货合同调用接口验证
    checkReturnContract () {
      let params = { contractId: this.$route.query.contractId };
      checkContractAbandonAssign(params).then(res => {
        let { status, err, data } = res.data;
        if (status === '200') {
          if (data === true) {
            this.dialogFormVisible = true;
          } else {
            this.$confirm(err, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.dialogFormVisible = true;
            }).catch(() => {});
          }
        }
      });
    },

    /**
     * @desc 换货合同提交验证
     * @param {number} total 【本次分配金额】总数
     */
    checkExchangeGoods (total) {
      if (total > this.info.unallocatedAmount) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
      } else {
        this.dialogFormVisible = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-btn-wrap{
  display: flex;
  flex-direction: row-reverse;
  padding-bottom: 10px;
}
</style>
